"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ = require("./");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff
// const { Fragment } = React;
// const { Paragraph } = Elements;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// eslint-disable-line import/no-extraneous-dependencies
// import PropTypes from 'prop-types';
// import _ from 'lodash';
var blockquoteStyle = (0, _glamor.css)({
  "& p": {
    fontSize: "inherit !important"
  }
});
// import moment from 'moment';

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// import { OutLink } from '@bodhi-project/components';
// import { Elements } from '@bodhi-project/typography';
// ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

var blockquoteStyleClass = blockquoteStyle.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/**
 * parserBlockquote
 */
var parserBlockquote = function parserBlockquote(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var descendants = element.children;

  return _react2.default.createElement(
    "blockquote",
    { className: "mask-p " + blockquoteStyleClass + " blockquote" },
    descendants.map(function (descendant) {
      var frag = (0, _.paragraphParser)(descendant, options);
      return frag;
    })
  );
};

parserBlockquote.propTypes = process.env.NODE_ENV !== "production" ? {} : {};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = parserBlockquote;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/blockquoteParser.js
// module id = 435
// module chunks = 168707334958949